// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDown_Container__vJbEO {
  display: flex;
  flex-direction: column;
}

.DropDown_label__MurJv {
  margin-bottom: 8px;
  color: var(--text-black-clr);
  text-transform: capitalize;
  font-weight: 400;
  font-size: 16px;
}
.DropDown_errorText__4H8H7 {
  color: red;
}

.DropDown_disabled__EiyJu {
  color: var(--disabled-label-clr);
}

.DropDown_reactSelect__huQwY {
}

/* On Hover */
.DropDown_dropdown__tm0lv:hover {
  border: 1px solid black !important;
  background-color: #f6f6f6;
}

/* on Focus */
.DropDown_dropdown__tm0lv:focus {
  border: 1px solid black;
}

/* On Active */
.DropDown_dropdown__tm0lv:active {
  border: 1px solid black;
}

/* On Disabled */
.DropDown_dropdown__tm0lv:disabled {
  background-color: #f6f6f6;
  color: #b5b5b5;
  border: 1px solid #e5e5e5;
}

.DropDown_noBorder__sBufE {
  border: 0px solid #e5e5e5;
}

.DropDown_arrow__dVD59 {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

/*  React Select */
.DropDown_leftIconBox__hF5KP {
  position: absolute;
  left: 20px;
  top: 55%;
  bottom: 45%;
  transform: translateY(-50%);
  height: max-content;
}

.DropDown_dropdownContainer__jT16C {
  position: relative;
  /* border: 1px solid var(--border-color); */
  border-radius: 6px;
  /* margin-bottom: 10px; */
}

.DropDown_optionContainer__LNJRl {
  display: flex;
  align-items: center;
  gap: 10px;
}

.DropDown_checkbox__UAv4R {
  margin-right: 8px; /* Space between checkbox and label */
}

.DropDown_optionLabel__e9LKb {
  cursor: pointer;
}

.DropDown_imageDiv__R8Mdz {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 30px;
  position: relative;
}

.DropDown_image__m2fXG {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/DropDown/DropDown.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;AACA;;AAEA,aAAa;AACb;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".Container {\n  display: flex;\n  flex-direction: column;\n}\n\n.label {\n  margin-bottom: 8px;\n  color: var(--text-black-clr);\n  text-transform: capitalize;\n  font-weight: 400;\n  font-size: 16px;\n}\n.errorText {\n  color: red;\n}\n\n.disabled {\n  color: var(--disabled-label-clr);\n}\n\n.reactSelect {\n}\n\n/* On Hover */\n.dropdown:hover {\n  border: 1px solid black !important;\n  background-color: #f6f6f6;\n}\n\n/* on Focus */\n.dropdown:focus {\n  border: 1px solid black;\n}\n\n/* On Active */\n.dropdown:active {\n  border: 1px solid black;\n}\n\n/* On Disabled */\n.dropdown:disabled {\n  background-color: #f6f6f6;\n  color: #b5b5b5;\n  border: 1px solid #e5e5e5;\n}\n\n.noBorder {\n  border: 0px solid #e5e5e5;\n}\n\n.arrow {\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n}\n\n/*  React Select */\n.leftIconBox {\n  position: absolute;\n  left: 20px;\n  top: 55%;\n  bottom: 45%;\n  transform: translateY(-50%);\n  height: max-content;\n}\n\n.dropdownContainer {\n  position: relative;\n  /* border: 1px solid var(--border-color); */\n  border-radius: 6px;\n  /* margin-bottom: 10px; */\n}\n\n.optionContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.checkbox {\n  margin-right: 8px; /* Space between checkbox and label */\n}\n\n.optionLabel {\n  cursor: pointer;\n}\n\n.imageDiv {\n  width: 30px;\n  height: 30px;\n  overflow: hidden;\n  border-radius: 30px;\n  position: relative;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `DropDown_Container__vJbEO`,
	"label": `DropDown_label__MurJv`,
	"errorText": `DropDown_errorText__4H8H7`,
	"disabled": `DropDown_disabled__EiyJu`,
	"reactSelect": `DropDown_reactSelect__huQwY`,
	"dropdown": `DropDown_dropdown__tm0lv`,
	"noBorder": `DropDown_noBorder__sBufE`,
	"arrow": `DropDown_arrow__dVD59`,
	"leftIconBox": `DropDown_leftIconBox__hF5KP`,
	"dropdownContainer": `DropDown_dropdownContainer__jT16C`,
	"optionContainer": `DropDown_optionContainer__LNJRl`,
	"checkbox": `DropDown_checkbox__UAv4R`,
	"optionLabel": `DropDown_optionLabel__e9LKb`,
	"imageDiv": `DropDown_imageDiv__R8Mdz`,
	"image": `DropDown_image__m2fXG`
};
export default ___CSS_LOADER_EXPORT___;
